import { render, staticRenderFns } from "./ChatDefaultContent.vue?vue&type=template&id=85c006f4&scoped=true"
import script from "./ChatDefaultContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatDefaultContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatDefaultContent.vue?vue&type=style&index=0&id=85c006f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c006f4",
  null
  
)

export default component.exports